export default  {
  bindings: {
    properties: '<'
  },
  controller: 'propertyListController',
  template: require('../views/property.list.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/components/property.list.component.js